import { createContext } from "react";

export const CandidateDBContext = createContext();